module.exports = __webpack_public_path__ + "img/4-01.76095b2e.png";